import { Component, OnInit } from '@angular/core';
import {environment} from '../../../../../../environments/environment.prod';
import {HeaderService} from '../../../../../services/header/header.service';
import {ActivatedRoute, Router} from '@angular/router';
interface TvaSummary {
    rate: string;
    base: number;
    amount: number;
}
@Component({
  selector: 'app-approve-bar-bon-liv',
  templateUrl: './approve-bar-bon-liv.component.html',
  styleUrls: ['./approve-bar-bon-liv.component.scss']
})
export class ApproveBarBonLivComponent implements OnInit {

    mode: 'validation' | 'apercu' = 'validation';

    file: string = environment.file_url;
    constructor(private headerService: HeaderService, private router : Router, private route: ActivatedRoute) { }
    tvaSummary: TvaSummary[] = [];
    totals = {
        totalHT: 0,
        totalTVA: 0,
        totalTTC: 0,
        timbreFiscal: 0.6,
        netAPayer: 0.6
    };
    ngOnInit(): void {
        this.mode = this.route.snapshot.paramMap.get('mode') as 'validation' | 'apercu';
        this.setHeaderConfig();

    }
    setHeaderConfig(): void {
        if (this.mode === 'validation') {
            this.headerService.setConfig({
                title: 'Bon de Livraison',
                buttons: [
                    { label: 'Retour', action: () => this.retour(), type: 'primary' },
                    { label: 'Annuler', action: () => this.retour(), type: 'secondary' },
                    { label: 'Livrer', action: () => this.retour(), type: 'primary' },


                ]
            });
        } else {
            this.headerService.setConfig({
                title: ' Bon de Livraison',
                buttons: [
                    { label: 'Mettre à jour', action: () => this.editagain(), type: 'primary' }
                ]
            });
        }
    }
    exportData() {
        console.log('Exporting data...');
    }

    retour() {
        this.router.navigate(['/vente/bon-livraison']);
    }
    editagain(){
        this.router.navigate(['/vente/bon-livraison/add-bon-livraison']);
    }

}
